import React,{Component,Fragment} from 'react';
import AppListItemLoading from '../pages/applistitemloading';
import AppItemNotFound from '../pages/appitemnotfound';
import { FilterConsumer } from '../context/FilterContext';
import scanlogo from '../assets/images/scanlogo.png';

import {
    Page,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    BlockTitle,
    Link,
    Block,
    Fab,
    Icon,
    Chip,
    Actions,
    ActionsGroup,
    ActionsLabel,
    ActionsButton  } from 'framework7-react';

  export default class MagazineSaleDetail extends Component {
    
    constructor(props) {
      
      super(props);

      let today = new Date();
      let currmonth = today.getMonth()+1;

      if(currmonth < 10)
      {
          currmonth = "0"+currmonth;
      }
      let currday = today.getDate();

      if(currday < 10)
      {
          currday = "0"+currday;
      }

      let startdate = today.getFullYear()+'-'+currmonth+'-01';
      let enddate   = today.getFullYear()+'-'+currmonth+'-'+currday;
     
      this.state = {
        clientdetail:[],
        startdate:startdate,
        enddate:enddate,
        isfetched:false,
        recordset:[],
        isptr:false,
        ismount:false,
        hasallcustomer:false,
        inventoryid:'',
        areaid:'',
        lineid:'',
        linemanid:'',
        hawkerid:'',
        hasfilter:true,
        filterinventoryname:'',
        filterarea:'',
        filterline:'',
        filterlineman:'',
        filterhawker:'',
        removefiltername:'',
        applyremovefilter:false,
        isdatafetched:false,
        effect:'blink',
        hasdataavailable:false,
        totalrecord:0,
        totalpayment:0,
        summarytotal:{totalamount:'0.00',totaldiscount:'0.00',totalcoupon:'0.00'},
      };

      this.handleUserInput      = this.handleUserInput.bind(this);
      this.getMagazineSaleDetail = this.getMagazineSaleDetail.bind(this);
      this.openFilterPopup      = this.openFilterPopup.bind(this);
      this.setNewFilterData     = this.setNewFilterData.bind(this);
      this.navigateToLink       = this.navigateToLink.bind(this);
    }
    
    componentDidMount(){
      
      let clientdetail   = JSON.parse(localStorage.getItem('agency_clientdetail'));

      this.setState(()=>{
        return{
          clientdetail:clientdetail,
          customerid:this.props.f7route.params.id
        }
      },()=>{

        setTimeout(()=> {

          this.setState({ismount:true});

        }, 1200);

        this.getMagazineSaleDetail();
        this.hideSplashScreen();
      });

    }

    hideSplashScreen(){
      document.getElementById("splash-screen").style.visibility = "hidden";
    }

    handleUserInput(e){

      const name  = e.target.name;
      const value = e.target.value;
      this.setState(()=>{
        return{
          [name]: value
        }
      });

    }

    getMagazineSaleDetail(){

        const self      = this;
        const app       = self.$f7;

        if(!this.$f7.online)
        {
          return;
        }
    
        const bodyFormData = {
            Mode:'GetMagazineSaleSummary',
            clientid:self.state.clientdetail.id,
            stateid:self.state.clientdetail.stateid,
            cityid:self.state.clientdetail.cityid,
            startdate:self.state.startdate,
            enddate:self.state.enddate,
            areaid:self.state.areaid,
            lineid:self.state.lineid,
            linemanid:self.state.linemanid,
            hawkerid:self.state.hawkerid,
            inventoryid:self.state.inventoryid,
        };

        this.setState(()=>{

          return{
            isfetched:false
          }
          
        },()=>{

          setTimeout(()=> {
  
          const accesstoken  = localStorage.getItem('agency_accesstoken');
          
          app.request.setup({
            headers:{
              Authorization: `${accesstoken}`
            }
          });
  
          app.request.promise.post(`${app.passedParams.serverurl}api/report.php?t=${Date.now()}`,bodyFormData)
          .then((res)=> {

              // Hide Pull To Refresh
              app.ptr.done();

              const resdata = JSON.parse(res.data);
    
              if(resdata.success === true)
              {
                this.setState({
                    isfetched:true,
                    recordset:resdata.paymentlist,
                    totalrecord:resdata.totalrecord,
                    totalpayment:resdata.totalpayment,
                    summarytotal:resdata.summarytotal,
                    hasdataavailable:true,
                },()=>{

                  this.Dom7('.outstandingwrapper').addClass('animate-bottom');

                });

              }
              else
              {
                this.setState({
                    isfetched:true,
                    hasdataavailable:false,
                    totalrecord:0,
                    totalpayment:0,
                    summarytotal:{totalamount:'0.00',totaldiscount:'0.00',totalcoupon:'0.00'},
                },()=>{

                  this.Dom7('.outstandingwrapper').addClass('animate-bottom');

                });
              }
    
          }).catch(e => {
              console.log(e);
          });

        },500);

      });
    }

    getMagazineSaleSummaryPDF(){

      const self      = this;
      const app       = self.$f7;

      const bodyFormData = {
        Mode:'GetMagazineSaleSummaryPDF',
        clientid:self.state.clientdetail.id,
        stateid:self.state.clientdetail.stateid,
        cityid:self.state.clientdetail.cityid,
        startdate:self.state.startdate,
        enddate:self.state.enddate,
        areaid:self.state.areaid,
        lineid:self.state.lineid,
        linemanid:self.state.linemanid,
        hawkerid:self.state.hawkerid,
        inventoryid:self.state.inventoryid,
        inventoryname:self.state.filterinventoryname,
      };

      if(this.state.isptr !== true)
      {
        app.preloader.show();
      }

      // Simulate Ajax Request
      setTimeout(()=> {

          const accesstoken  = localStorage.getItem('agency_accesstoken');
          
          app.request.setup({
            headers:{
              Authorization: `${accesstoken}`
            }
          });

          app.request.promise.post(`${app.passedParams.serverurl}api/report.php?t=${Date.now()}`,bodyFormData)
          .then((res)=> {

              // We got user data from request

              // Hide Preloader
              app.preloader.hide();

              // Hide Pull To Refresh
              app.ptr.done();                

              const resdata = JSON.parse(res.data);
              if(resdata.success === true)
              {
                  window.open(resdata.pdffilepath);
              }
              else
              {
                  const toastWithButton = app.toast.create({
                      text: resdata.msg,
                      closeButton: true,
                      closeTimeout: 3000,
                  });
                    
                  toastWithButton.open();    
              }
          }).catch(e => {
              console.log(e);
          });

      },500);
    }

    setNewFilterData(lineid, linemanid, hawkerid, filterline, filterlineman, filterhawker, areaid, filterarea, startdate, enddate, inventoryid, filterinventoryname){

      if(!this.$f7.online)
      {
        return;
      }

      Promise.all([
            
        setTimeout(()=> {

          this.Dom7('.waiting').addClass('animate-bottom');

        }, 50)

      ])
      .then(() => {

        this.setState(()=>{
        
          return{
            inventoryid:inventoryid,
            areaid:areaid,
            lineid:lineid,
            linemanid:linemanid,
            hawkerid:hawkerid,
            filterinventoryname:filterinventoryname,
            filterarea:filterarea,
            filterline:filterline,
            filterlineman:filterlineman,
            filterhawker:filterhawker,
            startdate:startdate,
            enddate:enddate,
            loaded:false,
            applyfilter:false,
            popupOpened:false,
            page:1,
          }
  
        },()=>{
  
          if(Number(this.state.lineid) > 0 || Number(this.state.linemanid) > 0 || Number(this.state.hawkerid) > 0 || Number(this.state.areaid) > 0 || (this.state.startdate !== "" && this.state.startdate !== undefined) || (this.state.enddate !== "" && this.state.enddate !== undefined))
          {
            this.setState({hasfilter:true,hasallcustomer:false});
          }
          else
          {
            this.setState({hasfilter:true,hasallcustomer:true});
          }
  
          this.getMagazineSaleDetail();
  
        });

      })
      
    }

    openFilterPopup(){
      
      if(!this.$f7.online)
      {
        return;
      }

      this.$f7router.navigate('filterpopup/');
    }

    deleteFilter(){

      this.setState({
        applyremovefilter:true
      })
    }

    navigateToLink(link){

      if(this.$f7.online)
      {
        this.$f7router.navigate(`/${link}/`);
        /*this.$f7.views.main.router.navigate(`/${link}/`);*/
      }

    }

    render(){
        
      const{isfetched, recordset, startdate, enddate, hasallcustomer, areaid, lineid, linemanid, hawkerid, hasfilter, filterarea, filterline, filterlineman, filterhawker, removefiltername, applyremovefilter, ismount, hasdataavailable, totalrecord, summarytotal, inventoryid, filterinventoryname} = this.state;

      let datestart     = "";
      let newstartdate  = "";

      if(startdate !== "" && startdate !== undefined)
      {
        newstartdate = new Date(startdate);

        let currmonth = newstartdate.getMonth()+1;
        if(currmonth < 10)
        {
            currmonth = "0"+currmonth;
        }
        datestart = newstartdate.getDate()+"-"+currmonth+"-"+newstartdate.getFullYear();
      }

      let dateend     = "";
      let newenddate  = "";

      if(enddate !== "" && enddate !== undefined)
      {
        newenddate = new Date(enddate);

        let currmonth = newenddate.getMonth()+1;
        if(currmonth < 10)
        {
            currmonth = "0"+currmonth;
        }
        dateend = newenddate.getDate()+"-"+currmonth+"-"+newenddate.getFullYear();
      }

      return(
        <Page className="page" name="MagazineSaleDetail">
        <Navbar sliding={true}>
          <NavLeft>
            <Link iconIos="f7:menu" iconAurora="f7:menu" iconMd="material:menu" panelOpen="left" className="smallbox"/>
            <Link href={`/dashboard/`} className="clearmenupadding">
              <img className="navbarlogo" src={scanlogo} alt="logo" />
            </Link>
          </NavLeft>
          <NavTitle>Magazine Sale Detail</NavTitle>
          <NavRight className="right-with-menu">
          <Link onClick={()=>{

            this.getMagazineSaleDetail();

          }} className="smallbox"><Icon f7="arrow_clockwise"/></Link>
          </NavRight>
        </Navbar>
      <FilterConsumer>{(value)=>{

        const{magazinesalefilterdata, applyMagazineSaleDetailFilter} = value;

        if(ismount === true)
        {
          setTimeout(()=> {

            if(removefiltername !== "" && this.state.applyremovefilter === true)
            {
              if(removefiltername === 'area')
              {
                applyMagazineSaleDetailFilter(lineid, linemanid, hawkerid, filterline, filterlineman, filterhawker, '', '', startdate, enddate);
              }
              else if(removefiltername === 'line')
              {
                applyMagazineSaleDetailFilter('', linemanid, hawkerid, '', filterlineman, filterhawker, areaid, filterarea, startdate, enddate, inventoryid, filterinventoryname);
              }
              else if(removefiltername === 'lineman')
              {
                applyMagazineSaleDetailFilter(lineid, '', hawkerid, filterline, '', filterhawker, areaid, filterarea, startdate, enddate, inventoryid, filterinventoryname);
              }
              else if(removefiltername === 'hawker')
              {
                applyMagazineSaleDetailFilter(lineid, linemanid, '', filterline, filterlineman, '', areaid, filterarea, startdate, enddate, inventoryid, filterinventoryname);
              }
              else if(removefiltername === 'daterange')
              {
                applyMagazineSaleDetailFilter(lineid, linemanid, hawkerid, filterline, filterlineman, filterhawker, areaid, filterarea, '', '', inventoryid, filterinventoryname);
              }
              else if(removefiltername === 'inventoryname')
              {
                applyMagazineSaleDetailFilter(lineid, linemanid, hawkerid, filterline, filterlineman, filterhawker, areaid, filterarea, startdate, enddate, '', '');
              }
            }

            if(((magazinesalefilterdata.lineid !== lineid) && magazinesalefilterdata.lineid !== undefined) || ((magazinesalefilterdata.linemanid !== linemanid) && magazinesalefilterdata.linemanid !== undefined) || ((magazinesalefilterdata.hawkerid !== hawkerid) && magazinesalefilterdata.hawkerid !== undefined) || ((magazinesalefilterdata.areaid !== areaid) && magazinesalefilterdata.areaid !== undefined) || ((magazinesalefilterdata.startdate !== startdate) && magazinesalefilterdata.startdate !== undefined) || ((magazinesalefilterdata.enddate !== enddate) && magazinesalefilterdata.enddate !== undefined) || ((magazinesalefilterdata.inventoryid !== inventoryid) && magazinesalefilterdata.inventoryid !== undefined) || applyremovefilter === true)
            {
              this.setNewFilterData(magazinesalefilterdata.lineid, magazinesalefilterdata.linemanid, magazinesalefilterdata.hawkerid, magazinesalefilterdata.filterline, magazinesalefilterdata.filterlineman, magazinesalefilterdata.filterhawker, magazinesalefilterdata.areaid, magazinesalefilterdata.filterarea, magazinesalefilterdata.startdate, magazinesalefilterdata.enddate, magazinesalefilterdata.inventoryid, magazinesalefilterdata.filterinventoryname);

              this.setState({
                removefiltername:'',
                applyremovefilter:false
              })

            }

          }, 500)
        }
        
      return(
            <Block>
              {
                hasfilter ? (
                  <Block strong className="selectedfilter" style={{marginTop:0}}>
                    {hasallcustomer ? (<Chip text={`Customer : All`} mediaBgColor="blue" media="A"/>):null}
                    {datestart ? (<Chip text={`Date : (${datestart}) - (${dateend})`} mediaBgColor="blue" media={`D`} 
                    onClick={()=>{
                        /*if(this.$f7.online)
                        {
                          this.setState(()=>{
                            return {
                              removefiltername:'daterange'
                            }
                          },()=>{
                            this.refs.actionsFilterGroup.open()
                          })
                        }*/
                      }}
                    />):null}
                    {areaid !== "" && filterarea !== "" ? (<Chip text={`Area : ${filterarea}`} mediaBgColor="pink" media={filterarea.toUpperCase().substring(0, 1)} deleteable
                    onClick={()=>{
                        if(this.$f7.online)
                        {
                          this.setState(()=>{
                            return {
                              removefiltername:'area'
                            }
                          },()=>{
                            this.refs.actionsFilterGroup.open()
                          })
                        }
                      }}
                    />):null}
                    {lineid !== "" && filterline !== "" ? (<Chip text={`Line : ${filterline}`} mediaBgColor="pink" media={filterline.toUpperCase().substring(0, 1)} deleteable
                    onClick={()=>{
                        if(this.$f7.online)
                        {
                          this.setState(()=>{
                            return {
                              removefiltername:'line'
                            }
                          },()=>{
                            this.refs.actionsFilterGroup.open()
                          })
                        }
                      }}
                    />):null}
                    {filterlineman ? (<Chip text={`Lineman : ${filterlineman}`} mediaBgColor="green" media={filterlineman.toUpperCase().substring(0, 1)} deleteable 
                    onClick={()=>{
                        if(this.$f7.online)
                        {
                          this.setState(()=>{
                            return {
                              removefiltername:'lineman'
                            }
                          },()=>{
                            this.refs.actionsFilterGroup.open()
                          })
                        }
                      }}
                    />):null}
                    {Number(hawkerid) > 0 && filterhawker !== "" ? (<Chip text={`Hawker : ${filterhawker}`} mediaBgColor="orange" media={filterhawker.toUpperCase().substring(0, 1)} deleteable 
                    onClick={()=>{
                        if(this.$f7.online)
                        {
                          this.setState(()=>{
                            return {
                              removefiltername:'hawker'
                            }
                          },()=>{
                            this.refs.actionsFilterGroup.open()
                          })
                        }
                      }}
                    />):null}
                    {inventoryid !== "" && filterinventoryname !== "" ? (<Chip text={`Inventory : ${filterinventoryname}`} mediaBgColor="pink" media={filterinventoryname.toUpperCase().substring(0, 1)} deleteable
                    onClick={()=>{
                        if(this.$f7.online)
                        {
                          this.setState(()=>{
                            return {
                              removefiltername:'inventoryname'
                            }
                          },()=>{
                            this.refs.actionsFilterGroup.open()
                          })
                        }
                      }}
                    />):null}
                    &nbsp;<Chip text="Modify" color="blue" onClick={()=>{
                        if(this.$f7.online)
                        {
                          this.$f7router.navigate(`filterpopup/?areaid=${areaid}&filterarea=${filterarea}&lineid=${lineid}&filterline=${filterline}&hawkerid=${hawkerid}&filterhawker=${filterhawker}&startdate=${startdate}&enddate=${enddate}&inventoryid=${inventoryid}&filterinventoryname=${filterinventoryname}`);
                        }
                    }}/>
                  </Block>
                ):null
              }
              {
                isfetched? (<Fragment>
                {
                  hasdataavailable ? (<Fragment>
                    <BlockTitle className="totalrec">Total Records : {totalrecord}</BlockTitle>
                    <div className="data-table">
                      <table>
                        <thead>
                          <tr>
                            <th className="label-cell">S.No.</th>
                            <th className="numeric-cell" style={{textAlign:'left'}}>Magazine</th>
                            <th className="numeric-cell">Quantity</th>
                            <th className="numeric-cell">&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          recordset.map((linedetail, lineloop)=>{

                          return(
                              <tr key={lineloop}>
                                <td className="label-cell">{linedetail.serialno}</td>
                                <td className="numeric-cell" style={{paddingRight:'0',paddingLeft:'0',textAlign:'left'}}>{linedetail.name}</td>
                                <td className="numeric-cell">{linedetail.quantity}</td>
                                <td className="numeric-cell">
                                  <Link className="dashboardlink" onClick={()=>{
                                    if(this.$f7.online)
                                    {
                                      this.$f7router.navigate(`detail/?areaid=${areaid}&filterarea=${filterarea}&lineid=${lineid}&filterline=${filterline}&hawkerid=${hawkerid}&filterhawker=${filterhawker}&startdate=${startdate}&enddate=${enddate}&inventoryid=${linedetail.id}&inventoryname=${linedetail.name}`);
                                    }
                                  }} ignoreCache={true}>
                                    <Icon f7="arrow_up_right_square_fill"></Icon>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })
                        }
                        {/*<tr>
                          <td className="label-cell">&nbsp;</td>
                          <td className="numeric-cell"><b>Total</b></td>
                          <td className="numeric-cell">{summarytotal.totalamount}</td>
                          <td className="numeric-cell">{summarytotal.totalcoupon}</td>
                          <td className="numeric-cell">{summarytotal.totaldiscount}</td>
                          <td className="numeric-cell">&nbsp;</td>
                        </tr>*/}
                      </tbody>
                      </table>
                    </div>
                  </Fragment>):(<AppItemNotFound notfoundtext ="No record found." />)
                }
                </Fragment>):(<AppListItemLoading />)
              }
              <br /><br /><br />
            </Block>
          );
        }}
        </FilterConsumer>
          <Actions ref="actionsFilterGroup">
            <ActionsGroup>
              <ActionsLabel bold>Are you sure?</ActionsLabel>
              <ActionsButton color="blue" bold onClick={()=>{this.deleteFilter()}}>Yes</ActionsButton>
            </ActionsGroup>
            <ActionsGroup>
              <ActionsButton color="red">No</ActionsButton>
            </ActionsGroup>
          </Actions>
          {
            hasdataavailable ? (
               <Fab position="center-bottom" slot="fixed" text="Download" onClick={()=>{
                    if(this.$f7.online)
                    {
                      this.getMagazineSaleSummaryPDF();
                    }
                  }}>
                  <Icon f7="printer_fill" style={{display:'inline-block'}}></Icon>
                  <Icon ios="f7:line_horizontal_3_decrease" aurora="f7:line_horizontal_3_decrease" md="material:filter_list"></Icon>
                </Fab>
            ):null
          }
        </Page>
      );
    }
}